const CACHE_KEY = 'ddc-geocode-cache-v1';
const MAX_CACHE_ENTRIES = 500;

// ── In-memory cache (avoids repeated JSON.parse per location) ──────────
let memoryCache = null;

/**
 * Load cache from localStorage into memory (once per session)
 * @returns {Object} - Cache map of address → { latitude, longitude }
 */
const getCache = () => {
	if (memoryCache !== null) {
		return memoryCache;
	}
	try {
		const raw = localStorage.getItem(CACHE_KEY);
		memoryCache = raw ? JSON.parse(raw) : {};
	} catch {
		memoryCache = {};
	}
	return memoryCache;
};

/**
 * Persist the in-memory cache to localStorage, evicting oldest entries if over limit
 */
const flushCache = () => {
	try {
		const cache = getCache();
		const keys = Object.keys(cache);
		if (keys.length > MAX_CACHE_ENTRIES) {
			const keysToKeep = keys.slice(keys.length - MAX_CACHE_ENTRIES);
			memoryCache = keysToKeep.reduce((acc, k) => {
				acc[k] = cache[k];
				return acc;
			}, {});
		}
		localStorage.setItem(CACHE_KEY, JSON.stringify(memoryCache));
	} catch {
		// localStorage full or unavailable — cache is best-effort
	}
};

/**
 * Look up cached coordinates for an address string
 * @param {string} address - The address key
 * @returns {{ latitude: number, longitude: number } | null}
 */
export const getCachedCoordinates = (address) => {
	return getCache()[address] || null;
};

/**
 * Store geocoded coordinates in the in-memory cache and flush to localStorage
 * @param {string} address - The address key
 * @param {{ latitude: number, longitude: number }} coordinates
 */
export const setCachedCoordinates = (address, coordinates) => {
	getCache()[address] = coordinates;
	flushCache();
};
